<app-dialog-container
  [title]="'Title.MainTitle.HistoryOfPurchase'"
  [subtitle]="'Help.Description.HistoryOfPurchase'"
  [size]="'large'"
  (closeDialogClicked)="closeDialog()"
>
  @if (isLoading() === false) {
    @if (purchaseHistoryOverview().length !== 0) {
      <table class="accumate-table">
        <thead>
          <tr>
            <th class="berry text-value">{{ "Table.Header.Name" | transloco }}</th>
            <th class="berry text-value">{{ "Table.Header.BookingDate" | transloco }}</th>
            <th class="berry text-value">{{ "Table.Header.ExpiryDate" | transloco }}</th>
            <th class="berry text-value">{{ "Table.Header.Country" | transloco }}</th>
            <th class="berry numeric-value">{{ "Table.Header.Quota" | transloco }}</th>
            <th class="berry numeric-value">{{ "Table.Header.RemainingQuota" | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (purchase of purchaseHistoryOverview(); track purchase) {
            <tr>
              <td class="text-value">{{ purchase.offerPackageName }}</td>
              <td class="text-value">{{ purchase.bookingDate | date: "dd.MM.yyyy" }} - {{ purchase.bookingDate | date: "HH:mm" }}</td>
              <td class="text-value">{{ purchase.bookingDate | date: "dd.MM.yyyy" }} - {{ purchase.bookingDate | date: "HH:mm" }}</td>
              <td class="text-value">
                @if (purchase.rightDEU) {
                  <span>{{ "Properties.Country.de" | transloco }}</span>
                }
                @if (purchase.rightDEU && purchase.rightAUT) {
                  <span>/</span>
                }
                @if (purchase.rightAUT) {
                  <span>{{ "Properties.Country.at" | transloco }}</span>
                }
              </td>
              <td class="numeric-value">{{ purchase.booking }}</td>
              <td class="numeric-value">{{ purchase.quota }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="flex align-middle items-center justify-center mt-2 w-full">{{ "Exception.Info.NoData" | transloco }} </div>
    }
  } @else {
    <app-table-skeleton-loader [numberOfRows]="5" [numberOfColumns]="6" />
  }
</app-dialog-container>
